(function () {
  const DESKTOP_QUERY = "(min-width: 768px)";

  function getSectionsToRender() {
    return [
      {
        id: "Cart",
        section: "main-cart",
        selector: ".thb-cart-form",
      },
      {
        id: "Cart-Drawer",
        section: "cart-drawer",
        selector: ".cart-drawer",
      },
      {
        id: "cart-drawer-toggle",
        section: "cart-bubble",
        selector: ".thb-item-count",
      },
    ];
  }

  function getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
    return parsed ? parsed.innerHTML : "";
  }

  function openCartDrawer() {
    const drawer = document.getElementById("Cart-Drawer");
    if (!drawer) return;

    drawer.classList.add("active");
    document.body.classList.add("open-cart");
    document.body.classList.add("open-cc");

    const recommendations = drawer.querySelector(".product-recommendations--full");
    if (recommendations) {
      recommendations.classList.add("active");
    }

    if (typeof CartDrawer !== "undefined") {
      new CartDrawer();
    }

    dispatchCustomEvent("cart-drawer:open");
  }

  function renderCartContents(parsedState) {
    getSectionsToRender().forEach((section) => {
      if (!document.getElementById(section.id)) return;

      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);

      if (!parsedState.sections || !parsedState.sections[section.section]) return;

      const sectionHtml = getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
      if (sectionHtml) {
        elementToReplace.innerHTML = sectionHtml;
      }
    });

    if (typeof Cart !== "undefined" && document.getElementById("Cart") && parsedState.sections) {
      new Cart().renderContents(parsedState);
    }

    openCartDrawer();
  }

  function addVariantToCart(variantId, loadingEl) {
    if (!variantId) return Promise.resolve();

    if (loadingEl) {
      loadingEl.classList.add("loading");
      loadingEl.setAttribute("aria-disabled", "true");
    }

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);
    formData.append(
      "sections",
      getSectionsToRender().map((section) => section.section)
    );
    formData.append("sections_url", window.location.pathname);

    return fetch(theme.routes.cart_add_url, {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/javascript",
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          return;
        }

        QuickAddDrawer.close();
        renderCartContents(response);

        dispatchCustomEvent("cart:item-added", {
          product: response.hasOwnProperty("items") ? response.items[0] : response,
        });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        if (loadingEl) {
          loadingEl.classList.remove("loading");
          loadingEl.removeAttribute("aria-disabled");
        }
      });
  }

  const QuickAddDrawer = {
    el: null,
    sizes: null,
    bound: false,

    init() {
      this.el = document.getElementById("Quick-Add-Drawer");
      if (!this.el || this.bound) return;

      this.sizes = this.el.querySelector(".quick-add-drawer__sizes");
      this.bound = true;

      this.el.addEventListener("click", (event) => {
        if (event.target === this.el) {
          this.close();
        }
      });

      this.el.querySelector("[data-quick-add-close]").addEventListener("click", () => {
        this.close();
      });

      this.sizes.addEventListener("click", (event) => {
        const button = event.target.closest(".quick-add__size");
        if (!button || button.disabled || button.dataset.available === "false") return;

        addVariantToCart(button.dataset.variantId, button);
      });

      document.addEventListener("keyup", (event) => {
        if (event.code && event.code.toUpperCase() === "ESCAPE") {
          this.close();
        }
      });

      const clickCapture = document.querySelector(".click-capture");
      if (clickCapture) {
        clickCapture.addEventListener("click", () => {
          if (document.body.classList.contains("open-quick-add")) {
            this.close();
          }
        });
      }
    },

    open(source) {
      this.init();
      if (!this.el) return;

      this.sizes.innerHTML = source.querySelector(".quick-add__sizes").innerHTML;
      this.sizes.querySelectorAll(".quick-add__size.is-selected").forEach((el) => {
        el.classList.remove("is-selected");
      });

      this.el.hidden = false;
      requestAnimationFrame(() => {
        this.el.classList.add("is-open");
      });

      document.body.classList.add("open-cc");
      document.body.classList.add("open-quick-add");
    },

    close() {
      if (!this.el) return;

      this.el.classList.remove("is-open");
      document.body.classList.remove("open-quick-add");

      if (!document.body.classList.contains("open-cart")) {
        document.body.classList.remove("open-cc");
      }

      setTimeout(() => {
        if (!this.el.classList.contains("is-open")) {
          this.el.hidden = true;
        }
      }, 350);
    },
  };

  if (!customElements.get("quick-add")) {
    class QuickAdd extends HTMLElement {
      connectedCallback() {
        this.addEventListener("click", this.onClick.bind(this));
      }

      isDesktop() {
        return window.matchMedia(DESKTOP_QUERY).matches;
      }

      onClick(event) {
        const trigger = event.target.closest(".quick-add__trigger");
        const sizeButton = event.target.closest(".quick-add__size");

        if (trigger) {
          event.preventDefault();
          event.stopPropagation();
          QuickAddDrawer.open(this);
          return;
        }

        if (!sizeButton || !this.isDesktop()) return;

        event.preventDefault();
        event.stopPropagation();

        if (sizeButton.disabled || sizeButton.dataset.available === "false") return;

        this.querySelectorAll(".quick-add__size").forEach((el) => {
          el.classList.remove("is-selected");
        });
        sizeButton.classList.add("is-selected");
        addVariantToCart(sizeButton.dataset.variantId, sizeButton);
      }
    }

    customElements.define("quick-add", QuickAdd);
  }

  window.initProductCardSliders = function initProductCardSliders() {
    if (typeof Swiper === "undefined") return;

    document.querySelectorAll(".product-card-slider").forEach((sliderEl) => {
      if (sliderEl.swiper || sliderEl.classList.contains("swiper-initialized")) return;
      const slideCount = sliderEl.querySelectorAll(".swiper-slide").length;

      new Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: '2px',
        loop: slideCount > 1,
        navigation: {
          nextEl: sliderEl.querySelector(".swiper-button-next"),
          prevEl: sliderEl.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: sliderEl.querySelector(".swiper-pagination"),
          type: "progressbar",
        },
      });
    });

    if (typeof window.applyProductCardView === "function") {
      window.applyProductCardView();
    }
  };

  document.addEventListener("DOMContentLoaded", () => {
    QuickAddDrawer.init();
    window.initProductCardSliders();
  });

  document.addEventListener("pagination:page-changed", () => {
    window.initProductCardSliders();
  });

  document.addEventListener("product-grid:updated", () => {
    window.initProductCardSliders();
  });
})();
